(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeContactFacilityTypeController', TypeContactFacilityTypeController);

    TypeContactFacilityTypeController.$inject = ['TypeContactFacilityType', 'CoreService',
        'GenericEntityDatatableService', '$uibModal', 'ConfirmationService', '$q'];

    function TypeContactFacilityTypeController(TypeContactFacilityType, CoreService,
                                               GenericEntityDatatableService, $uibModal, ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        var entityStateName = 'type-contact-facility-type';

        vm.descriptor = {
            title: 'Contact Facility Type',
            entityClassHumanized: 'Contact Facility Type',
            entityStateName: entityStateName,
            service: TypeContactFacilityType,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Contact Facility',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-contact-facility-type/update/type-contact-facility-type-dialog.html',
                controller: 'TypeContactFacilityTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-contact-facility-type/update/type-contact-facility-type-dialog.html',
                controller: 'TypeContactFacilityTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeContactFacilityType', function (TypeContactFacilityType) {
                        return TypeContactFacilityType.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Contact Facility Type').result.then(function () {
                    TypeContactFacilityType.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
